export default "__VITE_ASSET__5b5c4469__"